<script lang="ts" setup>
import { computed } from 'vue';
import { bootstrapPaddingBottomClass, bootstrapPaddingTopClass, BootstrapPaddingValue } from '../../lib/StyleHelpers';

    const props = defineProps<{
        topPadding?: BootstrapPaddingValue,
        bottomPadding?: BootstrapPaddingValue,
        autoSizeLeft?: boolean,
        autoSizeRight?: boolean
    }>();

    const rowClass = computed(() => {
        const classes = [
            "row",             
            bootstrapPaddingTopClass(props.topPadding) ?? "",
            bootstrapPaddingBottomClass(props.bottomPadding) ?? ""
        ];
        return classes;
    });

    const leftColumnClass = computed(() => {
        if (props.autoSizeLeft)
            return "col-auto text-start";
        return "col text-start";
    });

    const rightColumnClass = computed(() => {
        if (props.autoSizeRight)
            return "col-auto text-end";
        return "col text-end";
    });    

</script>

<template>    

    <div :class="rowClass">
        <!-- You can use either the default or the 'left' slot but not both to render into the left part of the row -->
        <template v-if="$slots.default">
            <div :class="leftColumnClass">
                <slot></slot>
            </div>
        </template>
        <template v-else-if="$slots.left">
            <div :class="leftColumnClass">
                <slot name="left"></slot>
            </div>
        </template>
    
        <template v-if="$slots.center">
            <div class="col text-center">
                <slot name="center"></slot>
            </div>
        </template>
    
        <template v-if="$slots.right">
            <div :class="rightColumnClass">
                <slot name="right"></slot>
            </div>
        </template>
    </div>
</template>